<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
  @import 'assets/css/style.css';
</style>
<style lang="scss">
 @import 'assets/css/variables.scss';
 @import 'assets/css/el-style.scss';
 @import 'assets/css/customer-style.scss';
</style>
